<div *ngIf="user">
  <mat-card>
    <mat-card-title>
      <h1>Forms |
        <span class="country">{{country ? user.weeeSystem.country.name : user.weeeSystem.description}}</span>
      </h1>
    </mat-card-title>
  </mat-card>
  <app-forms-filter
    (search)="searchForms($event)">
  </app-forms-filter>
  <mat-divider></mat-divider>
  <app-forms-table *ngIf="forms"
  [country]="country"
  [forms]="forms.content"
  [pageSize]="forms.size"
  [totalElements]="forms.totalElements"
  (loadForms)="loadForms($event)">
  </app-forms-table>
</div>
